import { ApplicationRef, inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';

let tickScheduled = false;

function scheduleAppTick(appRef: ApplicationRef): void {
  if (tickScheduled) {
    return;
  }

  tickScheduled = true;
  queueMicrotask(() => {
    tickScheduled = false;
    appRef.tick();
  });
}

export const zonelessChangeDetectionInterceptor: HttpInterceptorFn = (req, next) => {
  const appRef = inject(ApplicationRef);

  return next(req).pipe(
    finalize(() => {
      scheduleAppTick(appRef);
    })
  );
};
